<template>
  <div class="has-background-white">
    <br />
    <br />
    <div class="container" style="padding: 1rem;">
      <h3 class="is-size-4 has-text-primary">
        {{ $t("advantageTitle") }}
      </h3>
      <section class="table-container">
        <table class="table is-striped is-fullwidth">
          <thead>
            <tr>
              <th v-for="(col, i) in $t('advantageCols')" :key="i">
                <strong style="font-size: 18px">{{ col }}</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in $t('advantage')" :key="i">
              <td>{{ item.AnalizedCategory }}</td>
              <td class="has-text-primary has-text-weight-bold">
                {{ item.ceptinel }}
              </td>
              <td class="has-text-secondary">{{ item.competitors }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: "Advantage",
  data() {
    return {
      title: "Advantage",
    };
  },
};
</script>
<i18n>
{
   "es":{
      "advantageTitle":"Ventajas competitivas de Ceptinel",
      "advantageCols":[
         "Categoría analizada",
         "Ceptinel",
         "Principales competidores"
      ],
      "advantage":[
         {
            "AnalizedCategory":"Adaptabilidad a los datos del cliente y al modelo de negocio",
            "ceptinel":"ALTA",
            "competitors":"BAJA"
         },
         {
            "AnalizedCategory":"Período de implementación",
            "ceptinel":"REDUCIDO",
            "competitors":"EXTENSO"
         },
         {
            "AnalizedCategory":"Elaboración de reglas auditables",
            "ceptinel":"CUSTOMIZABLE",
            "competitors":"NO CUSTOMIZABLE"
         },
         {
            "AnalizedCategory":"Conectividad a los sistemas del cliente y datos externos vía API´s",
            "ceptinel":"TOTAL",
            "competitors":"PARCIAL"
         }
      ]
   },
   "en":{
      "advantageTitle":"Ceptinel competitive advantages",
      "advantageCols":[
         "Category analyzed",
         "Ceptinel",
         "Main Competitors"
      ],
      "advantage":[
         {
            "AnalizedCategory":"Adaptability to customer data and business model",
            "ceptinel":"HIGH",
            "competitors":"LOW"
         },
         {
            "AnalizedCategory":"Implementation period",
            "ceptinel":"REDUCED",
            "competitors":"EXTENSIVE"
         },
         {
            "AnalizedCategory":"Development of auditable rules",
            "ceptinel":"CUSTOMIZABLE",
            "competitors":"NOT CUSTOMIZABLE"
         },
         {
            "AnalizedCategory":"Connectivity to client systems and external data via API's",
            "ceptinel":"TOTAL",
            "competitors":"PARTIAL"
         }
      ]
   },
   "pt":{
      "advantageTitle":"Vantagens Competitivas do Ceptinel",
      "advantageCols":[
         "Categoria analisada",
         "Ceptinel",
         "Competidores principais"
      ],
      "advantage":[
         {
            "AnalizedCategory":"Adaptabilidade aos dados do cliente e modelo de negócios",
            "ceptinel":"ALTO",
            "competitors":"CURTO"
         },
         {
            "AnalizedCategory":"Período de implementação",
            "ceptinel":"REDUZIDO",
            "competitors":"EXTENSO"
         },
         {
            "AnalizedCategory":"Desenvolvimento de regras auditáveis",
            "ceptinel":"CUSTOMIZÁVEL",
            "competitors":"NÃO PERSONALIZE"
         },
         {
            "AnalizedCategory":"Conectividade com sistemas clientes e dados externos via API's",
            "ceptinel":"TOTAL",
            "competitors":"PARCIAL"
         }
      ]
   }
}
</i18n>
